import React from 'react';
import { Reveal } from './Reveal';
import type { GuideError } from '../data/guide';
type ErrorSectionProps = {
  item: GuideError;
  reversed: boolean;
};
export function ErrorSection({
  item,
  reversed
}: ErrorSectionProps) {
  return <article aria-labelledby={`error-${item.number}`} className="border-t border-beige/70 px-6 py-24 first:border-t-0 sm:px-10 sm:py-32" style={{
    paddingTop: "0px"
  }} data-id="element-21" data-mp="206fyzmxczd5z">
      <div className="mx-auto max-w-6xl" data-id="element-22" data-mp="29yllih4ud2ds">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-20" style={{
        gap: "0px"
      }} data-id="element-23" data-mp="29xiu883lwxxc">
          <Reveal as="figure" className={`lg:col-span-6 ${reversed ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-24" data-mp="2eyq6ajcs8j9t">
            <div className="grain group relative overflow-hidden rounded-[1.5rem] bg-cream sm:rounded-[2rem]" data-id="element-25" data-mp="2iwnx1qm7bdfb">
              
            </div>
          </Reveal>

          <div className={`lg:col-span-6 ${reversed ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-26" data-mp="olr6ofb5g8bp">
            <Reveal data-id="element-27" data-mp="tklphh949wvt">
              <div className="flex items-baseline gap-5" data-id="element-28" data-mp="tk2g4oxj8gte">
                <span className="font-serif text-[3.5rem] font-light leading-none text-sage-300 sm:text-[5rem]" data-id="element-29" data-mp="2mx5d6qi03jts">
                  {item.number}
                </span>
                <span className="mb-2 h-px flex-1 bg-beige" aria-hidden="true" data-id="element-30" data-mp="2i42nitgcguiv" />
                
              </div>
            </Reveal>

            <Reveal delay={0.06} data-id="element-31" data-mp="2960ebqmgivki">
              <h3 id={`error-${item.number}`} className="mt-7 font-serif text-[1.75rem] font-light leading-[1.25] tracking-[-0.01em] text-ink-900 sm:text-[2.35rem]" data-id="element-32" data-mp="297212scu56i2">
                {item.title}
              </h3>
            </Reveal>

            <Reveal delay={0.12} data-id="element-33" data-mp="2wutey0e0xrlg">
              <div className="mt-10 rounded-[1.5rem] border border-beige/80 bg-cream/60 p-7 sm:rounded-[1.75rem] sm:p-10" data-id="element-34" data-mp="2wtqnnrcshn50">
                <dl className="space-y-8" data-id="element-35" data-mp="2rvgqjb7i8cgr">
                  <div data-id="element-36" data-mp="1lfd4gzszdvvb">
                    <dt className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-ink-400" data-id="element-37" data-mp="1lgo5irv1kpiq">
                      Lo que muchas personas creen
                    </dt>
                    <dd className="mt-3 font-serif text-[1.25rem] italic leading-[1.6] text-ink-700 sm:text-[1.4rem]" data-id="element-38" data-mp="1hx75hdjr7103">
                      {item.belief}
                    </dd>
                  </div>

                  <div className="h-px bg-beige" aria-hidden="true" data-id="element-39" data-mp="18xtv8int28eb" />

                  <div data-id="element-40" data-mp="1dw3ryxp6hh21">
                    <dt className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-ink-400" data-id="element-41" data-mp="1dvc98ngojdt6">
                      La realidad
                    </dt>
                    <dd className="mt-3 font-sans text-[0.97rem] font-light leading-[1.9] text-ink-500" data-id="element-42" data-mp="13xxquib74ey8">
                      {item.reality}
                    </dd>
                  </div>

                  <div className="h-px bg-beige" aria-hidden="true" data-id="element-43" data-mp="q4q16w6odtj6" />

                  <div data-id="element-44" data-mp="u8nx6y0peo80">
                    <dt className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-sage-600" data-id="element-45" data-mp="u5s17f8f29m7">
                      Qué hacer en su lugar
                    </dt>
                    <dd className="mt-3 font-sans text-[0.97rem] font-light leading-[1.9] text-ink-700" data-id="element-46" data-mp="l6ogk6tlpm5l">
                      {item.action}
                    </dd>
                  </div>
                </dl>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </article>;
}